<template>
  <div class="page-legislacao-municipal">
    <div class="centro">
      <div class="titulo-pagina">
        <div class="triangulo-play"></div>
        <h1>
          <span>{{ enteFederativoNome }}</span>
        </h1>
      </div>
      <BuscaSimplesCards titulo="Consultas Rápidas" :cards="cards" />
    </div>
    <div class="pesquise">
      <div class="centro">
        <form @submit.prevent="buscar">
          <h2>PESQUISE AQUI</h2>
          <div class="row2">
            <div class="item">
              <label>Tipo de Veto</label>
              <!-- Mobile: campo customizado -->
              <div
                v-if="isMobile"
                class="mobile-multiselect-trigger"
                @click="abrirTipoVetoMobileDropdown"
              >
                <span v-if="tiposVetoSelecionadosMobile.length === 0"
                  >Escolha uma opção...</span
                >
                <span
                  v-else-if="tiposVetoSelecionadosMobile.length === 1"
                  class="tipo-nome-unico"
                  >{{ tiposVetoSelecionadosMobile[0].nome }}</span
                >
                <span v-else
                  >{{ tiposVetoSelecionadosMobile.length }} selecionados</span
                >
              </div>
              <multiselect
                v-else
                v-model="tiposVetoSelecionados"
                :options="tipos_veto"
                :multiple="true"
                :taggable="true"
                :searchable="true"
                :show-labels="false"
                placeholder="Escolha opções..."
                label="nome"
                track-by="id"
                class="multiselect-font font-black"
              >
              </multiselect>
            </div>
            <div class="item">
              <label>Tipo de Legislação</label>
              <!-- Mobile: campo customizado -->
              <div
                v-if="isMobile"
                class="mobile-multiselect-trigger"
                @click="abrirTipoLegislacaoMobileDropdown"
              >
                <span v-if="tipoLegislacaoSelecionadosMobile.length === 0"
                  >Escolha uma opção...</span
                >
                <span
                  v-else-if="tipoLegislacaoSelecionadosMobile.length === 1"
                  class="tipo-nome-unico"
                  >{{ tipoLegislacaoSelecionadosMobile[0].nome }}</span
                >
                <span v-else
                  >{{ tipoLegislacaoSelecionadosMobile.length }} selecionados</span
                >
              </div>
              <!-- Desktop: select normal -->
              <multiselect
                v-else
                v-model="tipoLegislacaoSelecionados"
                :options="tiposLegislacao"
                :multiple="true"
                :taggable="true"
                :searchable="true"
                :show-labels="false"
                placeholder="Escolha opções..."
                label="nome"
                track-by="id"
                class="multiselect-font font-black"
              />
            </div>
          </div>
          <div class="row2">
            <div class="grupo">
              <p>Data do Ofício</p>
              <div class="data">
                <div class="item">
                  <label>De</label>
                  <date-picker
                    v-model="filtro.periodo_inicial_mensagem"
                    :formatter="datepickerFormatter"
                  ></date-picker>
                </div>
                <div class="item">
                  <label>Até</label>
                  <date-picker
                    v-model="filtro.periodo_final_mensagem"
                    :formatter="datepickerFormatter"
                  ></date-picker>
                </div>
              </div>
            </div>
            <div class="direita">
              <div class="row2">
                <div class="item">
                  <label>Número</label>
                  <input type="text" v-model="filtro.numero" />
                </div>
                <div class="item">
                  <label>Ano</label>
                  <input type="text" v-model="filtro.ano" />
                </div>
              </div>
              <div>
                <label>Texto</label>
                <input type="text" v-model="filtro.conteudo" />
              </div>
            </div>
          </div>

          <div class="botoes">
            <button type="button" @click="limparFiltro">Limpar</button>
            <button type="submit">Buscar</button>
          </div>
        </form>
      </div>
    </div>
    <div class="centro campo-resultados" id="resultados">
      <div class="nav-resultados">
        <div class="first-flex">
          <h2>RESULTADOS DA PESQUISA</h2>
          <div
            class="dados-abertos"
            v-show="!carregando && !erro && !carregandoFiltros && !erroFiltros"
          >
            <p>
              <span>Dados Abertos:</span>
              <a @click="abrirDadosAbertos('json')">JSON</a>
              <a @click="abrirDadosAbertos('csv')">CSV</a>
            </p>
          </div>
        </div>
        <div class="second-flex">
          <ParametrosBusca
            :funcaoBuscaAvancada="buscar"
            :funcaoRemoveItemFiltro="removerItemFiltro"
            :tiposVeto="tipos_veto"
            :tiposLegislacao="tiposLegislacao"
            :filtro="filtro"
            contexto="mensagem_veto"
            v-show="!carregando && !erro && !carregandoFiltros && !erroFiltros"
          />
        </div>
        <div class="third-flex">
          <div
            class="nresultados"
            v-show="!carregando && !erro && !carregandoFiltros && !erroFiltros"
          >
            <p>
              <strong>{{ totalResultadosTexto }}</strong>
              {{ totalResultadosTexto === 1 ? 'resultado encontrado' : 'resultados encontrados' }}
            </p>
          </div>
          <div class="npagina" v-show="!carregando && !carregandoFiltros">
            <label>Resultados por Página</label>
            <select :value="qtd_por_pagina" @input="mudouQtdPagina">
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </div>
      </div>
      <div>
        <TabelaResultadosMensagemVeto
          :mensagensVeto="mensagensVeto"
          :isMunicipal="true"
          :municipioSlug="slug"
          v-if="!carregando && !erro && !carregandoFiltros && !erroFiltros"
        ></TabelaResultadosMensagemVeto>

        <Loading v-if="carregando || carregandoFiltros" size="medium"></Loading>
        <ErroResultados
          v-if="(!carregando || !carregandoFiltros) && (erro || erroFiltros)"
        ></ErroResultados>

        <paginate
          v-if="!erro && !carregando"
          v-model="pagina"
          :page-count="pageCount"
          :click-handler="mudouPagina"
          :prev-text="'Anterior'"
          :next-text="'Próxima'"
          :container-class="'className'"
          active-class="active-page"
        ></paginate>
      </div>
    </div>
    <div
      v-if="showTipoVetoMobileDropdown"
      class="mobile-dropdown-modal"
      @click.self="closeTipoVetoMobileDropdown"
    >
      <div class="mobile-dropdown-content">
        <ul class="mobile-dropdown-list">
          <li
            v-for="tipoVeto in tipos_veto"
            :key="tipoVeto.id"
            @click="toggleTipoVetoSelecionado(tipoVeto)"
            :class="{
              selected: tiposVetoSelecionadosMobile.some(
                (sel) => sel.id === tipoVeto.id
              ),
            }"
          >
            <input
              type="checkbox"
              :checked="
                tiposVetoSelecionadosMobile.some(
                  (sel) => sel.id === tipoVeto.id
                )
              "
              @change.prevent
            />
            {{ tipoVeto.nome }}
          </li>
        </ul>
        <button class="mobile-dropdown-apply" @click="aplicarTipoVetoSelecionados">
          Aplicar
        </button>
      </div>
    </div>
    <div
      v-if="showTipoLegislacaoMobileDropdown"
      class="mobile-dropdown-modal"
      @click.self="closeTipoLegislacaoMobileDropdown"
    >
      <div class="mobile-dropdown-content">
        <ul class="mobile-dropdown-list">
          <li
            v-for="tipoLegislacao in tiposLegislacao"
            :key="tipoLegislacao.id"
            @click="toggleTipoLegislacaoSelecionado(tipoLegislacao)"
            :class="{
              selected: tipoLegislacaoSelecionadosMobile.some(
                (sel) => sel.id === tipoLegislacao.id
              ),
            }"
          >
            <input
              type="checkbox"
              :checked="
                tipoLegislacaoSelecionadosMobile.some(
                  (sel) => sel.id === tipoLegislacao.id
                )
              "
              @change.prevent
            />
            {{ tipoLegislacao.nome }}
          </li>
        </ul>
        <button
          class="mobile-dropdown-apply"
          @click="aplicarTipoLegislacaoSelecionados"
        >
          Aplicar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// Bibliotecas
import { format, parseISO } from "date-fns";
import Paginate from "vuejs-paginate";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";
import Multiselect from "vue-multiselect";

// Componentes
import TabelaResultadosMensagemVeto from "@/components/pesquisa_mensagem_veto/TabelaResultadosMensagemVeto";
import Loading from "@/components/Loading";
import ErroResultados from "@/components/ErroResultados";
import ParametrosBusca from "@/components/ParametrosBusca";
import BuscaSimplesCards from "@/components/BuscaSimplesCards.vue";

// API, Mixins e helpers
import LegislacaoMunicipalApi from "@/services/LegislacaoMunicipalApi";
import { datepickerFormatter } from "@/helpers/datepickerFormatter";
import tryParseInt from "@/helpers/tryParseInt";

export default {
  name: "MensagensVetoPorEnteFederativo",
  props: {
    slug: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      enteFederativo: null,
      enteFederativoNome: null,
      mensagensVeto: [],
      carregando: true,
      erro: false,
      carregandoFiltros: true,
      erroFiltros: false,
      totalResultados: null,
      totalResultadosTexto: null,
      pagina: 1,
      qtd_por_pagina: 10,
      ordenarPor: null,
      filtro: {
        numero: null,
        conteudo: null,
        tipo_veto: [],
        tipo_legislacao: [],
        ementa: null,
        ano: null,
        periodo_inicial_mensagem: null,
        periodo_final_mensagem: null,
        periodo_inicial_diario: null,
        periodo_final_diario: null,
      },
      tipos_veto: [],
      tiposVetoSelecionados: [],
      tiposVetoSelecionadosMobile: [],
      tiposLegislacao: [],
      tipoLegislacaoSelecionados: [],
      tipoLegislacaoSelecionadosMobile: [],
      datepickerFormatter,
      isMobile: window.innerWidth < 600,
      showTipoVetoMobileDropdown: false,
      showTipoLegislacaoMobileDropdown: false,
    };
  },
  components: {
    TabelaResultadosMensagemVeto,
    Paginate,
    DatePicker,
    Loading,
    ErroResultados,
    ParametrosBusca,
    Multiselect,
    BuscaSimplesCards,
  },
  created() {
    this.legislacaoApi = new LegislacaoMunicipalApi();
    this.obterEnteFederativo().then(async () => {
      this.carregarQtdPorPagina();
      await this.carregarTiposLegislacao();
      await this.carregarValoresFiltro();
      this.carregarMensagensVeto();
    });
    window.addEventListener("resize", this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkMobile);
  },
  mounted() {
      window.addEventListener('resize', this.checkMobile);

      if (this.$route.query && Object.keys(this.$route.query).length > 0) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.$scrollTo("#resultados", 700, {
              offset: -100,
              cancelable: false,
              onDone: () => this.focusResultados(),
            });
          }, 500);
        });
      }
    },
  watch: {
    $route: async function (to, from) {
      if (
        to.name == "MensagensVetoPorEnteFederativo" &&
        JSON.stringify(to.query) !== JSON.stringify(from.query)
      ) {
        this.syncFiltroFromRoute();
        await this.carregarTiposLegislacao();
        await this.carregarValoresFiltro();
        this.carregarMensagensVeto();
      }
    },
  },

  methods: {
    syncFiltroFromRoute() {
      this.pagina = parseInt(this.getParam("pagina") || 1);
      this.ordenarPor = this.getParam("ordenarPor") || "data";

      let tipo_veto = this.getParam("tipo_veto");
      if (Array.isArray(tipo_veto)) {
        tipo_veto = tipo_veto.map(Number);
      } else if (typeof tipo_veto === "string" && tipo_veto.includes(",")) {
        tipo_veto = tipo_veto.split(",").map(Number);
      } else if (tipo_veto) {
        tipo_veto = [Number(tipo_veto)];
      } else {
        tipo_veto = [];
      }

      let tipo_legislacao = this.getParam("tipo_legislacao");
      if (Array.isArray(tipo_legislacao)) {
        tipo_legislacao = tipo_legislacao.map(Number);
      } else if (typeof tipo_legislacao === "string" && tipo_legislacao.includes(",")) {
        tipo_legislacao = tipo_legislacao.split(",").map(Number);
      } else if (tipo_legislacao) {
        tipo_legislacao = [Number(tipo_legislacao)];
      } else {
        tipo_legislacao = [];
      }

      this.filtro = {
        numero: this.getParam("numero"),
        conteudo: this.getParam("conteudo"),
        tipo_veto: tipo_veto,
        tipo_legislacao: tipo_legislacao,
        ementa: this.getParam("ementa"),
        ano: this.getParam("ano"),
        ...this.convertPeriodosStringParaDatas(),
      };
    },
    atualizarOrdenacao(event) {
      this.ordenarPor = event.target.value;
      this.buscar(event);
    },
    async obterEnteFederativo() {
      try {
        const allEntesFederativos =
          await this.legislacaoApi.getEntesFederativos();
        this.enteFederativo = allEntesFederativos.find(
          (ente) => ente.slug === this.slug
        );
        if (!this.enteFederativo) {
          this.erro = true;
          console.error(
            "Ente Federativo não encontrado para o slug: ",
            this.slug
          );
        }
      } catch (err) {
        console.error("Erro ao obter Ente Federativo: ", err);
        this.erro = true;
      }
    },
    mudouQtdPagina: function (event) {
      const novaQtdPagina = parseInt(event.target.value);
      if (novaQtdPagina < this.qtd_por_pagina) {
        this.qtd_por_pagina = novaQtdPagina;
        this.mudouPagina(this.pagina);
      } else {
        let novaPagina = Math.ceil(
          (this.qtd_por_pagina * this.pagina) / novaQtdPagina
        );

        this.qtd_por_pagina = novaQtdPagina;
        this.mudouPagina(novaPagina);
      }
    },
    getParam: function (name) {
      if (this.$route && this.$route.query) {
        return this.$route.query[name];
      }
      return null;
    },
    buscar: function (event) {
      event.preventDefault();

      this.filtro.tipo_veto = this.tiposVetoSelecionados.map((t) => t.id);
      this.filtro.tipo_legislacao = this.tipoLegislacaoSelecionados.map(
        (t) => t.id
      );

      const filtroLimpo = { ...this.filtro };
      Object.keys(filtroLimpo).forEach((key) => {
        const valor = filtroLimpo[key];
        if (
          valor === null ||
          valor === undefined ||
          valor === "" ||
          (Array.isArray(valor) && valor.length === 0)
        ) {
          delete filtroLimpo[key];
        }
      });

      this.$router.push({
        name: "MensagensVetoPorEnteFederativo",
        params: { slug: this.slug },
        query: {
          ...filtroLimpo,
          pagina: 1,
          qtd_por_pagina: this.qtd_por_pagina,
          ordenarPor: this.ordenarPor,
          ...this.convertePeriodosDatasParaString(),
        },
      });

      this.$scrollTo("#resultados", 700, {
        offset: -100,
        cancelable: false,
      });
    },
    mudouPagina: function (page) {
      this.pagina = page;
      this.ordenarPor = this.getParam("ordenarPor");

      const filtro = {
        numero: this.getParam("numero"),
        conteudo: this.getParam("conteudo"),
        tipo_veto: this.getParam("tipo_veto"),
        tipo_legislacao: this.getParam("tipo_legislacao"),
        ementa: this.getParam("ementa"),
        ano: this.getParam("ano"),
        periodo_inicial_mensagem: this.getParam("periodo_inicial_mensagem"),
        periodo_final_mensagem: this.getParam("periodo_final_mensagem"),
        periodo_inicial_diario: this.getParam("periodo_inicial_diario"),
        periodo_final_diario: this.getParam("periodo_final_diario"),
      };

      this.$router.push({
        name: "MensagensVetoPorEnteFederativo",
        params: { slug: this.slug },
        query: {
          ...filtro,
          pagina: this.pagina,
          qtd_por_pagina: this.qtd_por_pagina,
          ordenarPor: this.ordenarPor,
        },
      });
      this.$scrollTo("#resultados", 0, {
        offset: -100,
        cancelable: false,
      });
    },
    carregarValoresFiltro: async function () {
      try {
        this.carregandoFiltros = true;
        this.erroFiltros = false;

        this.tipos_veto = await this.legislacaoApi.getTiposVeto(
          this.enteFederativo.id
        );
        if (this.filtro.tipo_veto) {
          const filtros = Array.isArray(this.filtro.tipo_veto)
            ? this.filtro.tipo_veto
            : [this.filtro.tipo_veto];

          this.tiposVetoSelecionados = this.tipos_veto.filter((tipo) =>
            filtros.some((filtro_tipo) => filtro_tipo == tipo.id)
          );
          this.tiposVetoSelecionadosMobile = [...this.tiposVetoSelecionados];
        } else {
          this.tiposVetoSelecionados = [];
          this.tiposVetoSelecionadosMobile = [];
        }

        if (this.filtro.tipo_legislacao) {
          const filtros = Array.isArray(this.filtro.tipo_legislacao)
            ? this.filtro.tipo_legislacao
            : [this.filtro.tipo_legislacao];
          this.tipoLegislacaoSelecionados = this.tiposLegislacao.filter(
            (tipo) => filtros.some((f) => f == tipo.id)
          );
          this.tipoLegislacaoSelecionadosMobile = [
            ...this.tipoLegislacaoSelecionados,
          ];
        } else {
          this.tipoLegislacaoSelecionados = [];
          this.tipoLegislacaoSelecionadosMobile = [];
        }

        this.carregandoFiltros = false;
      } catch (err) {
        console.log("carregarValoresFiltro", err);
        this.carregandoFiltros = false;
        this.erroFiltros = true;
        this.tipos_veto = [];
      }
    },
    carregarMensagensVeto: async function () {
      try {
        this.carregando = true;
        this.erro = false;

        this.qtd_por_pagina =
          this.getParam("qtd_por_pagina") || this.qtd_por_pagina;

        this.armazenarQtdPorPagina();
        this.syncFiltroFromRoute();

        if (this.legislacaoApi.cancelTokens.getMensagensVetoByEnteFederativo) {
          this.legislacaoApi.cancelTokens.getMensagensVetoByEnteFederativo.cancel();
        }

        if (!this.enteFederativo || !this.enteFederativo.id) {
          console.error(
            "ID do Ente Federativo não disponível para carregar mensagens de veto."
          );
          this.erro = true;
          this.carregando = false;
          return;
        }

        const params = {
          ...this.filtro,
          page: this.pagina,
          qtd_por_pagina: this.qtd_por_pagina,
          ordenarPor: this.ordenarPor,
          ...this.convertePeriodosDatasParaString(),
        };

        const data =
          await this.legislacaoApi.getMensagensVetoByEnteFederativo(
            this.enteFederativo.id,
            params
          );

        this.enteFederativoNome = data.ente_federativo.nome;
        this.mensagensVeto = data.resultados;
        this.totalResultados = data.total_resultados;
        this.totalResultadosTexto =
          data.total_resultados.toLocaleString("pt-BR");
        this.carregando = false;
      } catch (err) {
        if (this.legislacaoApi.isCancel(err)) {
          return;
        }
        console.log("carregarMensagensVeto", err);
        this.carregando = false;
        this.erro = true;
      }
    },
    limparFiltro: function () {
      this.filtro = {
        numero: null,
        conteudo: null,
        tipo_veto: [],
        tipo_legislacao: [],
        ementa: null,
        ano: null,
        periodo_inicial_mensagem: null,
        periodo_final_mensagem: null,
        periodo_inicial_diario: null,
        periodo_final_diario: null,
      };
      this.tiposVetoSelecionados = [];
      this.tiposVetoSelecionadosMobile = [];
      this.tipoLegislacaoSelecionados = [];
      this.tipoLegislacaoSelecionadosMobile = [];
    },
    convertePeriodosDatasParaString: function () {
      return {
        periodo_inicial_mensagem: this.filtro.periodo_inicial_mensagem
          ? format(this.filtro.periodo_inicial_mensagem, "yyyy-MM-dd")
          : null,
        periodo_final_mensagem: this.filtro.periodo_final_mensagem
          ? format(this.filtro.periodo_final_mensagem, "yyyy-MM-dd")
          : null,
        periodo_inicial_diario: this.filtro.periodo_inicial_diario
          ? format(this.filtro.periodo_inicial_diario, "yyyy-MM-dd")
          : null,
        periodo_final_diario: this.filtro.periodo_final_diario
          ? format(this.filtro.periodo_final_diario, "yyyy-MM-dd")
          : null,
      };
    },
    convertPeriodosStringParaDatas: function () {
      const periodo_inicial_mensagem = this.getParam(
        "periodo_inicial_mensagem"
      );
      const periodo_final_mensagem = this.getParam("periodo_final_mensagem");
      const periodo_inicial_diario = this.getParam("periodo_inicial_diario");
      const periodo_final_diario = this.getParam("periodo_final_diario");

      return {
        periodo_inicial_mensagem: periodo_inicial_mensagem
          ? parseISO(periodo_inicial_mensagem)
          : null,
        periodo_final_mensagem: periodo_final_mensagem
          ? parseISO(periodo_final_mensagem)
          : null,
        periodo_inicial_diario: periodo_inicial_diario
          ? parseISO(periodo_inicial_diario)
          : null,
        periodo_final_diario: periodo_final_diario
          ? parseISO(periodo_final_diario)
          : null,
      };
    },
    armazenarQtdPorPagina() {
      localStorage.setItem(
        "qtd_por_pagina_mensagens_veto",
        this.qtd_por_pagina
      );
    },
    carregarQtdPorPagina() {
      const qtd = localStorage.getItem("qtd_por_pagina_mensagens_veto");
      if (qtd) {
        this.qtd_por_pagina = tryParseInt(qtd);
      }
    },
    checkMobile() {
      this.isMobile = window.innerWidth < 600;
    },
    abrirTipoVetoMobileDropdown() {
      this.tiposVetoSelecionadosMobile = [...this.tiposVetoSelecionados];
      this.showTipoVetoMobileDropdown = true;
    },
    closeTipoVetoMobileDropdown() {
      this.showTipoVetoMobileDropdown = false;
    },
    toggleTipoVetoSelecionado(option) {
      const id = option && option.id;
      const nome = option && option.nome;
      const idx = this.tiposVetoSelecionadosMobile.findIndex(
        (sel) => sel.id === id
      );
      if (idx === -1) this.tiposVetoSelecionadosMobile.push({ id, nome });
      else this.tiposVetoSelecionadosMobile.splice(idx, 1);
    },
    aplicarTipoVetoSelecionados() {
      this.tiposVetoSelecionados = [...this.tiposVetoSelecionadosMobile];
      this.showTipoVetoMobileDropdown = false;
    },
    abrirTipoLegislacaoMobileDropdown() {
      this.tipoLegislacaoSelecionadosMobile = [
        ...this.tipoLegislacaoSelecionados,
      ];
      this.showTipoLegislacaoMobileDropdown = true;
    },
    closeTipoLegislacaoMobileDropdown() {
      this.showTipoLegislacaoMobileDropdown = false;
    },
    toggleTipoLegislacaoSelecionado(option) {
      const idx = this.tipoLegislacaoSelecionadosMobile.findIndex(
        (sel) => sel.id === option.id
      );
      if (idx === -1) this.tipoLegislacaoSelecionadosMobile.push(option);
      else this.tipoLegislacaoSelecionadosMobile.splice(idx, 1);
    },
    aplicarTipoLegislacaoSelecionados() {
      this.tipoLegislacaoSelecionados = [
        ...this.tipoLegislacaoSelecionadosMobile,
      ];
      this.showTipoLegislacaoMobileDropdown = false;
    },
    removerItemFiltro({ key, id }) {
      if (key === "tipo_veto") {
        this.tiposVetoSelecionados = this.tiposVetoSelecionados.filter(
          (item) => item.id.toString() !== id.toString()
        );
        this.tiposVetoSelecionadosMobile = [...this.tiposVetoSelecionados];
      } else if (key === "tipo_legislacao") {
        this.tipoLegislacaoSelecionados = this.tipoLegislacaoSelecionados.filter(
          (item) => item.id.toString() !== id.toString()
        );
        this.tipoLegislacaoSelecionadosMobile = [
          ...this.tipoLegislacaoSelecionados,
        ];
      } else if (key === 'ano') {
        this.$set(this.filtro, 'ano', null);
        const mockEvent = { preventDefault: () => {} };
        this.buscar(mockEvent);
        return;
      } else if (key === 'periodo') {
        this.$set(this.filtro, 'periodo_inicial', null);
        this.$set(this.filtro, 'periodo_final', null);
        const mockEvent = { preventDefault: () => {} };
        this.buscar(mockEvent);
        return;
      }
      const mockEvent = { preventDefault: () => {} };
      this.buscar(mockEvent);
    },
    async carregarTiposLegislacao() {
      try {
        this.tiposLegislacao =
          await this.legislacaoApi.getTiposByEnteFederativo(
            this.enteFederativo.id
          );
      } catch (e) {
        this.tiposLegislacao = [];
      }
    },
  },
  computed: {
    pageCount: function () {
      if (
        this.totalResultados != undefined &&
        this.totalResultados != null &&
        this.qtd_por_pagina != null &&
        this.qtd_por_pagina != undefined &&
        this.totalResultados > 0 &&
        this.qtd_por_pagina > 0
      ) {
        return Math.ceil(this.totalResultados / this.qtd_por_pagina);
      }
      return 0;
    },
    cards() {
      return [
        {
          rota: {
            name: "MensagensVetoPorEnteFederativoPorTipoLegislacao",
            params: { slug: this.slug },
          },
          icone: require("@/assets/images/icon-tipo-legislacao2.png"),
          iconeClasse: "legisla-icon",
          titulo: "Tipo de Legislação",
          descricao:
            "Consulte as Mensagens de Veto<br /> por <strong>tipo de legislação</strong>",
        },
        {
          rota: {
            name: "MensagensVetoPorEnteFederativoPorTipoVeto",
            params: { slug: this.slug },
          },
          icone: require("@/assets/images/icon-tipo-legislacao2.png"),
          iconeClasse: "legisla-icon",
          titulo: "Tipo de Veto",
          descricao:
            "Consulte as Mensagens de Veto<br /> por <strong>tipo</strong>",
        },
        {
          rota: {
            name: "MensagensVetoPorEnteFederativoPorAno",
            params: { slug: this.slug },
          },
          icone: require("@/assets/images/icon-indice-cronologico2.png"),
          iconeClasse: "indice-icon",
          titulo: "Índice Cronológico",
          descricao:
            "Consulte as Mensagens de Veto<br /> por <strong>ano</strong>",
        },
      ];
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
h1 span {
  background-color: #ffb24e;
  color: #0e489f;
  border-radius: 12px;
  padding: 0 0.3rem;
  margin: 0; /* Remove a margem interna do h1 */
  display: inline;
  line-height: normal; /* Ajusta a altura da linha */
  -webkit-box-decoration-break: clone;
  box-decoration-break: clone; /* limita o fundo ao tamanho do texto */
}

.titulo-pagina {
  display: flex;
  align-items: center;
  gap: 1rem;
  // margin: 2rem 0 1.5rem 0;
}

.triangulo-play {
  width: 0;
  height: 0;
  border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
  border-left: 25px solid #0e489f;
}
/* Alinha o título com os demais blocos em telas até 1023px */
@media screen and (max-width: 1023px) {
  .titulo-pagina {
    margin-left: 1rem;
  }
}
.info-field {
  position: relative;
  display: inline-block;
  margin-left: 1rem;
}

.info-button {
  width: 30px;
  height: 30px;
  background-color: #ffa900;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.info-button:hover {
  background-color: #ffaa00ae;
}

.info-icon {
  color: #115810;
  font-weight: bold;
  font-size: 18px;
}

@media screen and (min-width: 320px) and (max-width: 425px) {
  .info-tooltip {
    width: 60vw;
    height: max-content;
    position: absolute;
    transform: translateX(-50%);
    background-color: #ffa900;
    padding: 10px;
    border-radius: 4px;
    display: none;
    z-index: 1;
    margin-top: 0.5rem;
  }

  .info-field:hover .info-tooltip {
    display: block;
  }

  .info-content {
    color: black;
    .exemplo {
      color: #115810;
      font-weight: bold;
    }
  }

  div.info-content h2 {
    color: #115810;
    border-bottom: #115810 solid 0.15rem;
    margin-bottom: 1rem;
  }

  .info-content p {
    margin: 0;
    padding: 0;
    margin-bottom: 5px;
  }
}

@media screen and (min-width: 426px) and (max-width: 1024px) {
  .info-tooltip {
    width: 60vw;
    height: max-content;
    position: absolute;
    transform: translateX(-50%);
    background-color: #ffa900;
    padding: 10px;
    border-radius: 4px;
    display: none;
    z-index: 1;
    margin-top: 0.5rem;
    left: 20vw;
  }

  .info-field:hover .info-tooltip {
    display: block;
  }

  .info-content {
    color: black;
    .exemplo {
      color: #115810;
      font-weight: bold;
    }
  }

  div.info-content h2 {
    color: #115810;
    border-bottom: #115810 solid 0.15rem;
    margin-bottom: 1rem;
  }

  .info-content p {
    margin: 0;
    padding: 0;
    margin-bottom: 5px;
  }
}

@media screen and (min-width: 1025px) and (max-width: 1440px) {
  .info-tooltip {
    width: max-content;
    height: max-content;
    position: absolute;
    transform: translateX(-50%);
    background-color: #ffa900;
    padding: 1rem;
    border-radius: 4px;
    display: none;
    z-index: 1;
    margin-top: 0.5rem;
    left: 25vw;
  }

  .info-field:hover .info-tooltip {
    display: block;
  }

  .info-content {
    color: black;
    .exemplo {
      color: #115810;
      font-weight: bold;
    }
  }

  div.info-content h2 {
    color: #115810;
    border-bottom: #115810 solid 0.15rem;
    margin-bottom: 1rem;
  }

  .info-content p {
    margin: 0;
    padding: 0;
    margin-bottom: 5px;
  }
}

@media screen and (min-width: 1441px) and (max-width: 2560px) {
  .info-tooltip {
    width: max-content;
    height: max-content;
    position: absolute;
    transform: translateX(-50%);
    background-color: #ffa900;
    padding: 1rem;
    border-radius: 4px;
    display: none;
    z-index: 1;
    margin-top: 0.5rem;
    left: 15vw;
  }

  .info-field:hover .info-tooltip {
    display: block;
  }

  .info-content {
    color: black;
    .exemplo {
      color: #115810;
      font-weight: bold;
    }
  }

  div.info-content h2 {
    color: #115810;
    border-bottom: #115810 solid 0.15rem;
    margin-bottom: 1rem;
  }

  .info-content p {
    margin: 0;
    padding: 0;
    margin-bottom: 5px;
  }
}

.pesquise {
  background-color: #115810;
  padding: 0.5rem 1rem 5rem; /* igual à PesquisaLegislacao */
  h2 {
    color: white;
    font-family: "Poppins-Bold";
    font-size: 1.1rem;
    display: inline-table;
    margin: 0rem;
    padding-right: 1rem;
    width: fit-content;
  }
  label {
    color: white;
    font-size: 0.9rem;
  }
  input {
    border: none;
    width: calc(100% - 0.8rem);
    height: 2rem;
    border-radius: 0.2rem;
    border: none;
    padding-left: 0.5rem;
    font-family: "Poppins";
    letter-spacing: 0.03rem;
    font-size: 1rem;
  }
  .campo-preenchido {
    background-color: #fffed4;
  }
  select {
    width: calc(100% - 0.2rem);
    height: 2rem;
    border: none;
    border-radius: 0.2rem;
    padding-left: 0.5rem;
    background-color: white;
    font-family: "Poppins";
    letter-spacing: 0.03rem;
    font-size: 1rem;
  }
  .grupo {
    border: #ffa900 solid 0.15rem;
    margin: 0.5rem 0rem;
    padding: 0.5rem 0.5rem;
    border-radius: 0.5rem;
    .data {
      display: grid;
      grid-template-columns: auto auto;
      gap: 1rem;
      .mx-datepicker {
        width: 100%;
      }
      .mx-input {
        height: 1rem !important;
      }
    }
    p {
      margin: 0rem;
      padding: 0rem;
      color: white;
    }
  }
  .botoes {
    float: right;
    margin: 1rem 0rem;
    button {
      margin-left: 1rem;
      padding: 0.1rem 2rem;
      font-family: "Poppins-Medium";
      font-size: 0.9rem;
    }
    button:first-child {
      background: transparent;
      border: white solid 0.15rem;
      color: white;
      padding: 0.1rem 2rem;
      cursor: pointer;
    }
    button:last-child {
      background-color: #ffa900;
      color: #2c3f2b;
      border: solid 0.15rem #ffa900;
      cursor: pointer;
    }
  }
  .item {
    display: grid;
    margin: 0.5rem 0rem;
  }
  .seta {
    img {
      width: 5rem;
      position: absolute;
      right: 1rem;
      margin-top: 3.5rem;
    }
    .t-preto {
      display: none;
    }
  }
}
.campo-resultados {
  margin: 1rem;
  h2 {
    color: #083e07;
    font-family: "Anton", sans-serif;
    font-size: 1.1rem;
    display: table;
    padding-right: 1rem;
    margin: 1.5rem 0rem 0rem 1rem;
  }
  .dados-abertos {
    width: fit-content;
    margin: 1rem auto 0;
    padding: 0;
    p {
      display: inline-flex;
      align-items: center;
      gap: 1rem;
      margin: 0;
      background-color: #d3d4d3;
      padding: 0.2rem 0.75rem;
      font-size: 0.9rem;
      font-family: "Poppins", sans-serif;
      color: #083e07;
      border-radius: 0.2rem;
      line-height: 1.2;
      -webkit-box-decoration-break: clone;
      box-decoration-break: clone;
    }
      span,
      a {
        margin: 0;
      }
    a {
      text-decoration: none;
      color: #083e07;
      font-family: "Poppins-Medium";
      cursor: pointer;
    }
  }
  .nav-resultados {
    margin: 0 1rem 0 1rem;
    // margin-bottom: 2rem;
    display: grid;

    .first-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 1rem 0;

      h2 {
        margin: 0;
      }

      .dados-abertos {
        padding-left: 0;
        margin: 0;
      }
    }

    .second-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0.3rem 0;

      .ordenacao {
        margin: 0;
        display: flex;
        align-items: center;
      }
    }

    .third-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 1rem 0;

      .nresultados {
        margin: 0;
        width: fit-content;
        height: fit-content;

        p {
          display: block;
          width: fit-content;
          height: fit-content;
          font-size: 0.9rem;
          margin: 0rem;
          strong {
            font-family: "Poppins-Medium";
            color: #083e07;
          }
        }
      }

      .npagina {
        margin: 0;
        text-align: end;

        label {
          font-family: "Poppins-Medium";
          font-weight: 900;
          margin-right: 0.5rem;
          color: #2c3f2b;
          font-size: 0.9rem;
        }
        select {
          border: none;
          background-color: #d3d4d3;
          font-size: 0.9rem;
          margin-top: 0.5rem;
        }
      }
    }
  }
  .nav-resultados {
    margin-bottom: 2rem;
  }
  .nresultados {
    p {
      font-size: 0.8rem;
      margin: 0.2rem 0rem -2.5rem 1rem;
      strong {
        font-family: "Poppins-Medium";
        color: #083e07;
      }
    }
  }
  .npagina {
    margin: 0.5rem 1rem 0.5rem 1rem;
    label {
      font-family: "Poppins-Medium";
      font-weight: 900;
      margin-right: 0.5rem;
      color: #2c3f2b;
      font-size: 0.8rem;
    }
    select {
      border: none;
      background-color: #d3d4d3;
      font-size: 0.9rem;
      margin-top: 0.5rem;
    }
  }
}
@media screen and (min-width: 31rem) {
  .nav-resultados {
    margin-bottom: 0rem !important;
  }
  .nresultados {
    p {
      margin-bottom: 0rem !important;
    }
  }
}
@media screen and (min-width: 64rem) {
  h1 {
    margin-left: 0rem;
    font-size: 1.75rem;
  }
  .pesquise {
    padding-bottom: 5rem !important; /* igual à PesquisaLegislacao */
    h2 {
      margin-top: 1rem;
      margin-bottom: 1rem;
      font-size: 1.3rem;
    }
    .row2 {
      grid-template-columns: calc(50% - 0.5rem) calc(50% - 0.5rem);
      gap: 1rem;
      display: grid;
    }
    .grupo {
      padding: 0.65rem 2rem;
    }
    .botoes {
      margin-right: 0.3rem;
      margin-top: 0.5rem;
      button {
        font-size: 1rem;
        padding: 0.1rem 4rem !important;
        border-radius: 0.2rem;
      }
    }
    .seta {
      img {
        right: 5rem;
        margin-top: 3.5rem;
      }
    }
  }
  .campo-resultados {
    // background-color: #efeeed;
    
    h2 {
      font-family: 'Anton', sans-serif;
      font-size: 1.5rem;
      margin-left: 0rem;
      color: #083e07;
    }
    .dados-abertos {
      width: fit-content;
      margin: -2rem 1rem 0rem auto;
      p {
        font-size: 0.8rem;
        gap: 0.5rem;
        padding: 0 0.5rem;
        height: 1.2rem;
      }
      span,
      a {
        font-size: 0.8rem;
      }
    }
    .npagina {
      text-align: right;
      label {
        font-size: 0.8rem;
      }
    }
    .nresultados {
      max-width: 17rem;
      text-align: left;
      margin: 0rem 0rem 2rem;
      p {
        font-size: 0.8rem;
        margin: -1.5rem 0rem 0rem 0rem;
        text-align: left;
        strong {
          font-family: "Poppins-Medium";
        }
      }
    }
  }
}
.alto-contraste {
  .pesquise {
    background-color: #115810;
    .seta {
      .t-branco {
        display: none;
      }
      .t-preto {
        display: block;
      }
    }
    .botoes {
      button:last-child {
        background-color: #ffa900;
        color: #0d2b10;
        font-family: "Poppins-Medium";
      }
    }
  }
  .nav-resultados {
    h2 {
      color: white;
    }
  }
  .npagina {
    label {
      color: white !important;
    }
  }
  .nresultados {
    color: white;
    
    p {
      color: white !important;
      
      strong {
        color: white !important;
      }
    }
  }
}
.pesquise .multiselect__content-wrapper {
  position: fixed !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  top: auto !important;
  max-height: 50vh !important;
  min-height: 100px;
  overflow-y: auto !important;
  z-index: 9999 !important;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.multiselect__content {
  max-height: 50vh !important;
  height: auto !important;
  overflow-y: auto !important;
}
.mobile-dropdown-modal {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.2);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mobile-dropdown-content {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  width: 90vw;
  max-width: 400px;
  max-height: 70vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.mobile-dropdown-header {
  padding: 1rem;
  border-bottom: 1px solid #eee;
  text-align: right;
  background: #f5f5f5;
}
.mobile-dropdown-header button {
  background: #ffa900;
  color: #2c3f2b;
  border: none;
  border-radius: 4px;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  cursor: pointer;
}
.mobile-dropdown-list {
  flex: 1;
  overflow-y: auto;
  list-style: none;
  margin: 0;
  padding: 0;
}
.mobile-dropdown-list li {
  padding: 1rem;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  font-size: 1.1rem;
  transition: background 0.2s;
}
.mobile-dropdown-list li.selected,
.mobile-dropdown-list li:hover {
  background: #083e07;
  color: #fff;
}
.mobile-multiselect-trigger {
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fff;
  color: #333;
  font-size: 1rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0 8px 0 8px;
  margin: 0;
  height: auto;
  min-height: 34px;
  width: 100%;
  box-sizing: border-box;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
}
.mobile-multiselect-trigger:after {
  content: "\25BC";
  margin-left: auto;
  color: #aaa;
}
.mobile-dropdown-input {
  width: 100%;
  padding: 0.75rem 1rem;
  border: none;
  border-bottom: 1px solid #eee;
  font-size: 1.1rem;
  outline: none;
  box-sizing: border-box;
}
.mobile-dropdown-apply {
  width: 100%;
  padding: 1rem;
  background: #083e07;
  color: #fff;
  border: none;
  border-top: 1px solid #eee;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  border-radius: 0 0 8px 8px;
  transition: background 0.2s;
}
.mobile-dropdown-apply:active {
  background: #368f6e;
}
.mobile-dropdown-list li input[type="checkbox"] {
  margin-right: 1rem;
  accent-color: #083e07;
}
.chip-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 2px;
}
.chip {
  display: block;
  background: #e6f4f1;
  color: #2c3f2b;
  border-radius: 12px;
  padding: 6px 10px;
  font-size: 0.95em;
  border: 1px solid #083e07;
  white-space: normal;
  width: 100%;
  box-sizing: border-box;
}
.mobile-multiselect-trigger .chip-list {
  max-height: 80px;
  overflow-y: auto;
  margin-bottom: 2px;
}
.mobile-multiselect-trigger {
  overflow: hidden;
}
.row2mobile {
  align-items: start;
}
.chip-list-mobile {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 80px;
  margin-bottom: 2px;
  gap: 6px;
}
.chip-list-mobile .chip {
  display: block;
  width: 100%;
  box-sizing: border-box;
}

.tipo-nome-unico {
  display: block;
  width: 100%;
  max-width: 100%;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
  font-weight: 600;
  color: #2c3f2b;
}
.chip-remove {
  margin-left: 8px;
  color: #e74c3c;
  font-weight: bold;
  cursor: pointer;
  font-size: 1.1em;
}
.chip-remove:hover {
  color: #c0392b;
}
.centro {
  max-width: 90%;
  margin: 0 auto;
}
.nav-resultados {
  margin-left: 1rem;
  display: grid;

  .first-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 1rem 0;

    h2 {
      margin: 0;
    }

    .dados-abertos {
      padding-left: 0;
      margin: 0;
    }
  }

  .second-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0.3rem 0;

    .ordenacao {
      margin: 0;
      display: flex;
      align-items: center;
    }
  }

  .third-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 1rem 0;

    .nresultados {
      margin: 0;
      width: fit-content;
      height: fit-content;

      p {
        display: block;
        width: fit-content;
        height: fit-content;
        font-size: 0.9rem;
        margin: 0rem;
        strong {
          font-family: "Poppins-Medium";
        }
      }
    }

    .npagina {
      margin: 0;

      label {
        font-family: "Poppins-Medium";
        font-weight: 900;
        margin-right: 0.5rem;
        color: #2c3f2b;
        font-size: 0.9rem;
      }
      select {
        border: none;
        background-color: #edf2ee;
        font-size: 0.9rem;
        margin-top: 0.5rem;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .dados-abertos p {
    display: inline-flex;
    align-items: center;
    gap: 0.75rem;
    width: auto;
    min-width: fit-content;
    font-size: 0.7rem !important;
    -webkit-box-decoration-break: clone;
    box-decoration-break: clone;
  }
}
</style>
